export default __webpack_public_path__ + "static/media/no-volatility-risks.b2264079.png";